// ============================================================================
// FILE: src/modules/uploads/constants/uploadConstants.js
// MODULE: Generic Upload Framework
//
// PURPOSE:
// Central constants used by the Generic Upload Framework.
//
// NOTES:
// - Do not hardcode step numbers.
// - Do not hardcode upload status.
// - Used by UploadDrawer and all upload step components.
// ============================================================================
//
// AUTHOR:
// DizyPro ERP Development Team
// ============================================================================


// ============================================================================
// Upload Wizard Steps
// ============================================================================

export const STEP_CONFIGURE = 1;

export const STEP_TEMPLATE = 2;

export const STEP_UPLOAD = 3;

export const STEP_VALIDATE = 4;

export const STEP_IMPORT = 5;

export const STEP_COMPLETE = 6;


// ============================================================================
// Upload Wizard Step List
// ============================================================================

export const UPLOAD_STEPS = [

    {
        id: STEP_CONFIGURE,
        key: "CONFIGURE",
        title: "Configure"
    },

    {
        id: STEP_TEMPLATE,
        key: "TEMPLATE",
        title: "Template"
    },

    {
        id: STEP_UPLOAD,
        key: "UPLOAD",
        title: "Upload"
    },

    {
        id: STEP_VALIDATE,
        key: "VALIDATE",
        title: "Validate"
    },

    {
        id: STEP_IMPORT,
        key: "IMPORT",
        title: "Import"
    },

    {
        id: STEP_COMPLETE,
        key: "COMPLETE",
        title: "Complete"
    }

];


// ============================================================================
// Upload Wizard Navigation
// ============================================================================

export const FIRST_STEP =
    STEP_CONFIGURE;

export const LAST_STEP =
    STEP_COMPLETE;


// ============================================================================
// Upload Progress Status
// ============================================================================

export const PROGRESS_READY =
    "READY";

export const PROGRESS_RUNNING =
    "RUNNING";

export const PROGRESS_COMPLETED =
    "COMPLETED";

export const PROGRESS_FAILED =
    "FAILED";


// ============================================================================
// Upload Job Status
// (Must match Backend Constants)
// ============================================================================

export const STATUS_UPLOADED =
    "UPLOADED";

export const STATUS_VALIDATING =
    "VALIDATING";

export const STATUS_VALIDATED =
    "VALIDATED";

export const STATUS_IMPORTING =
    "IMPORTING";

export const STATUS_COMPLETED =
    "COMPLETED";

export const STATUS_PARTIAL_SUCCESS =
    "PARTIAL_SUCCESS";

export const STATUS_FAILED =
    "FAILED";

export const STATUS_CANCELLED =
    "CANCELLED";


// ============================================================================
// Default Upload Wizard State
// ============================================================================

export const DEFAULT_UPLOAD_STATE = {

    currentStep: STEP_CONFIGURE,

    selectedUploadType: "",

    selectedFile: null,

    uploadJob: null,

    validationResult: null,

    importResult: null,

    loading: false,

    error: null

};


// ============================================================================
// End of File
// ============================================================================